import React, { useState, useEffect } from 'react';
import { DatePicker, Card, Row, Col, Alert, Divider, } from 'antd';
import { Column, Line, Area } from '@ant-design/charts';
import { getSalesReportGraph } from "../../../actions/report";
import moment from 'moment';
import { connect } from "react-redux";

const { RangePicker } = DatePicker;

const GraphChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dateRange, setDateRange] = useState([
    moment().subtract(7, 'days'),
    moment(),
  ]);

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getSalesReportGraph(
        dateRange[0].format("YYYY-MM-DD"),
        dateRange[1].format("YYYY-MM-DD"),
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );
  
      if (response && Array.isArray(response)) {
        const processedData = processChartData(response);
        console.log("Processed Data:", processedData);
        setData(processedData);
      } else {
        setError("No data received or invalid data format");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message || "Failed to fetch data");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const processChartData = (invoices) => {
    if (!Array.isArray(invoices)) return [];
    
    const dailyData = {};
    
    invoices.forEach(invoice => {
      const date = moment(invoice.issue_date).format('YYYY-MM-DD');
      
      if (!dailyData[date]) {
        dailyData[date] = {
          date,
          invoiceCount: 0,
          totalBill: 0,
        };
      }
      
      dailyData[date].invoiceCount += 1;
      dailyData[date].totalBill += parseFloat(invoice.bill) || 0;
    });
    
    const result = [];
    Object.entries(dailyData).forEach(([date, values]) => {
      result.push({
        date,
        type: 'Invoice Count',
        value: values.invoiceCount,
      });
      result.push({
        date,
        type: 'Total Bill',
        value: values.totalBill,
      });
    });
    
    return result.sort((a, b) => new Date(a.date) - new Date(b.date));
  };
  

  const config = {
    data,
    xField: 'date',
    yField: 'value',
    isGroup: true,
    seriesField: 'type',
    legend: {
      position: 'top',
    },
    isStack: true,
    tooltip: {
      shared: true,
      showMarkers: true,
      formatter: (datum) => {
        return {
          name: datum.type,
          value:
            datum.type === 'Invoice Count'
              ? `${datum.value || 0} invoices`
              : `৳${(datum.value || 0).toFixed(2)}`,
        };
      },
    },
    xAxis: {
      label: {
        autoRotate: false,
      },
    },
    yAxis: {
      label: {
        formatter: (val) => `৳${val}`,
      },
    },
  };

  return (
    <Card 
      title="Sales Analytics" 
      loading={loading}
      extra={
        <RangePicker
          value={dateRange}
          onChange={(dates) => setDateRange(dates)}
          disabledDate={(current) => current && current > moment().endOf('day')}
        />
      }
    >
      {error && (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      
      {!loading && data.length === 0 && !error && (
        <Alert
          message="No Data"
          description="No invoices found for the selected date range"
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <Divider style={{ fontSize: "18px", marginTop:"10px" }}>Line Area Chart</Divider>
      <Row gutter={16}>
        <Col span={24}>
          {data.length > 0 ? (
            // <Column {...config} />
            // <Line {...config} />
            <Area {...config} />

          ) : (
            <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {!loading && <p>No data to display</p>}
            </div>
          )}
        </Col>
      </Row>

      <Divider style={{ fontSize: "18px", marginTop:"10px" }}>Column Chart</Divider>
      <Row gutter={16}>
        <Col span={24}>
          {data.length > 0 ? (
            <Column {...config} />
            // <Line {...config} />
            // <Area {...config} />

          ) : (
            <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {!loading && <p>No data to display</p>}
            </div>
          )}
        </Col>
      </Row>
    </Card>
  );
};


export default GraphChart;
